<div class="d-flex align-items-center">
  @if (diasRestantes >= 0 || isPlazoAmpliado || isFinanciado) {
<span class="material-symbols-outlined me-1" [ngClass]="{
            'primary-900': !plataforma,
            'secondary-venture-500' : plataforma === 'venture', 
            'secondary-estate-500': plataforma === 'realestate',
            'secondary-creative-500' : plataforma === 'creative'
        }">
      schedule
    </span>
  }
  <span class="p2-medium neutral-800 mb-0">
    @if (!isPlazoAmpliado && !isFinanciado) {
      @if (diasRestantes > 0) {
        <strong class="p2-bold me-1">{{diasRestantes}}</strong>
      }

      @if (diasRestantes == 0) {
        Último día
      }
      @if (diasRestantes == 1) {
        día <span class="d-inline-block">restante</span>
      }
      @if (diasRestantes > 1) {
        días <span class="d-inline-block">restantes</span>
      }
    }
    @if (isPlazoAmpliado) {
      Plazo ampliado
    }
    @if (isFinanciado) {
      Financiado
    }
  </span>
</div>